module.exports = __webpack_public_path__ + "static/media/logo.84c8af7a.png";